export const siteInfo = {
  name: '色里番精选推荐',
  tagline: '探索色里番的完整世界',
  description: '精选高品质色里番作品分类导航，涵盖热门番剧、新番推荐、经典回顾等内容。为色里番爱好者提供一站式资源发现平台。',
  email: 'contact@tomleeled.cn',
  foundingYear: '2020',
  teamSize: '50+',
  totalWorks: '5000+',
  monthlyVisitors: '100万+',
  features: [
    { icon: 'ri-star-line', title: '精选推荐', desc: '专业团队精心筛选，只推荐高品质色里番作品，告别低质内容。' },
    { icon: 'ri-compass-3-line', title: '完整分类', desc: '涵盖热门番剧、新番推荐、经典回顾等多维度分类体系。' },
    { icon: 'ri-flashlight-line', title: '实时更新', desc: '紧跟最新番剧动态，第一时间推送新番资讯和资源更新。' },
    { icon: 'ri-shield-check-line', title: '品质保证', desc: '严格的内容审核机制，确保每部推荐作品都经过精心甄选。' },
  ],
  timeline: [
    { year: '2020', title: '平台创立', desc: '由一群色里番爱好者共同创立，致力于打造专业的内容推荐平台。' },
    { year: '2021', title: '内容体系建设', desc: '建立完整的分类体系和评审标准，收录超过1000部优质作品。' },
    { year: '2022', title: '用户快速增长', desc: '月活跃用户突破50万，成为色里番领域最具影响力的推荐平台之一。' },
    { year: '2023', title: '品牌升级', desc: '全面升级平台体验，推出个性化推荐算法，用户满意度大幅提升。' },
    { year: '2024', title: '生态扩展', desc: '拓展多元内容生态，月访问量突破100万，持续引领行业发展。' },
  ],
  testimonials: [
    { name: '动漫达人小王', role: '资深番剧爱好者', content: '色里番精选推荐是我每天必逛的平台，分类清晰、推荐精准，帮我发现了超多宝藏作品！' },
    { name: '资深宅友小李', role: 'ACG文化研究者', content: '这个平台的专业性令人惊叹，每部推荐作品都有详细的分析和介绍，品质真的很高。' },
    { name: '资深老宅老张', role: '五年忠实用户', content: '从平台创立初期就开始使用，见证了它一步步成长。推荐质量一直很稳定，值得信赖。' },
  ],
}

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '热门推荐', href: '/category/hot' },
  { label: '新番速递', href: '/category/new' },
  { label: '经典回顾', href: '/category/classic' },
  { label: '排行榜', href: '/category/ranking' },
  { label: '关于我们', href: '/about' },
]